var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.99988C12.6946 2.99988 15.225 4.1926 16.9425 6.27228L15.7859 7.22755C14.3544 5.49408 12.2454 4.49995 10 4.49995C5.86458 4.49995 2.5 7.86445 2.5 12C2.5 16.1355 5.86457 19.5 10 19.5C12.2454 19.5 14.3544 18.5058 15.7859 16.7724L16.9424 17.7276C15.2249 19.8072 12.6946 21 10 21C5.03732 21 1 16.9626 1 12C1 7.03743 5.03732 2.99988 10 2.99988Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12L18.5 6.75003L17.4394 7.8106L20.8789 11.25H8V12.75H20.8789L17.4394 16.1895L18.5 17.25L23.75 12Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutput);
export default __webpack_public_path__ + "static/media/ic-output.b838ace4ddf49365cfdfca0b163a98e8.svg";
export { ForwardRef as ReactComponent };